export function isCachedNavlError(error, destinations) {
    const isCachedDest = destinations === null || destinations === void 0 ? void 0 : destinations.every((d) => d === null || d === void 0 ? void 0 : d.isCached);
    return (isCachedDest &&
        (error.message.includes('Hotel Get Details 404') || error.message.includes('Hotel Get Details 500 Exception')));
}
